import { render, staticRenderFns } from "./ExchangeFormPage.vue?vue&type=template&id=6d800981&scoped=true"
import script from "./ExchangeFormPage.vue?vue&type=script&lang=js"
export * from "./ExchangeFormPage.vue?vue&type=script&lang=js"
import style0 from "./ExchangeFormPage.vue?vue&type=style&index=0&id=6d800981&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d800981",
  null
  
)

export default component.exports